import { cardBrandDataMap } from '../constants';

import type { TokenexBrand } from '../components/ui/CardBrandIcon';

/**
 * Generate standardized card brand name matching Tokenex's expected input,
 * from the given card type string.
 *
 * Accepts all known card brand name variations & formats as input.
 * Returns 'unknown' if the card type is not recognized.
 *
 * ### Examples
 * ```
 * getCardBrandTokenexName('master');
 * // => 'masterCard'
 *
 * getCardBrandTokenexName('MasterCard');
 * // => 'masterCard'
 *
 * getCardBrandTokenexName('silly card');
 * // => 'unknown'
 * ```
 */
export const getCardBrandTokenexName = (cardType: string): TokenexBrand => {
  if (!cardType) return 'unknown';

  const cardTypeLc = cardType?.toLowerCase();

  // Find the card type in the human-readable map
  const cardTypeClean = cardBrandDataMap?.[cardTypeLc];
  if (cardTypeClean) return cardTypeClean.id;

  // Fallback to 'unknown' if not found
  return 'unknown';
};
